import { ChangeDetectionStrategy, Component, computed, HostListener, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ContactActionsService } from '../../services/contact-actions.service';
import { UserProfileService } from '../../services/user-profile.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  protected readonly auth = inject(AuthService);
  private readonly userProfile = inject(UserProfileService);
  protected readonly contactActions = inject(ContactActionsService);

  /** If logged in and goal is set, returns the goal score; otherwise null */
  protected readonly userGoal = computed(() => {
    if (!this.auth.isAuthenticated()) return null;
    const profile = this.userProfile.profile();
    return profile?.goal ?? null;
  });

  protected readonly clbCards = [
    { level: 'CLB 6', score: '7-8-9', cefr: 'B1', color: 'var(--clb-6)', minHeight: '4.5rem', textLight: false },
    { level: 'CLB 7', score: '10-11', cefr: 'B2', color: 'var(--clb-7)', minHeight: '5rem', textLight: false },
    { level: 'CLB 8', score: '12-13', cefr: 'B2', color: 'var(--clb-8)', minHeight: '5.5rem', textLight: false },
    { level: 'CLB 9', score: '14-15', cefr: 'C1', color: 'var(--clb-9)', minHeight: '6rem', textLight: true },
    { level: 'CLB 10+', score: '16-20', cefr: 'C1-C2', color: 'var(--clb-10)', minHeight: '6.5rem', textLight: true }
  ] as const;

  protected readonly showBackToTop = signal(false);

  @HostListener('window:scroll')
  onWindowScroll() {
    this.showBackToTop.set(window.scrollY > 300);
  }

  scrollToPricing(): void {
    document.getElementById('pricing-title')?.scrollIntoView({ behavior: 'smooth' });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

